// 💰 Cash-register "ka-ching" for every new order (user 2026-10-25: "a money machine sound instead of 'هناك طلب جديد', in
// all pages, especially orders"). Synthesized with Web Audio — no file to load: the drawer's mechanical "cha", the bell
// "ching", then a few coins.
export const playCash = (c: AudioContext | null | undefined, vol = 1) => {
  if (!c || c.state !== 'running') return;
  const t = c.currentTime + 0.02;
  const out = c.createGain(); out.gain.value = 0.9 * vol; out.connect(c.destination);
  // "cha": short filtered noise burst (the drawer)
  const n = c.createBuffer(1, Math.floor(c.sampleRate * 0.09), c.sampleRate); const d = n.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 2);
  const src = c.createBufferSource(), bp = c.createBiquadFilter(), ng = c.createGain();
  src.buffer = n; bp.type = 'bandpass'; bp.frequency.value = 2500; bp.Q.value = 0.8; ng.gain.value = 0.55;
  src.connect(bp).connect(ng).connect(out); src.start(t);
  // "ching": bright bell, a few partials
  const bell = (f: number, at: number, dur: number, g: number) => {
    const o = c.createOscillator(), gg = c.createGain(); o.type = 'sine'; o.frequency.value = f;
    gg.gain.setValueAtTime(0.0001, at); gg.gain.exponentialRampToValueAtTime(g, at + 0.008); gg.gain.exponentialRampToValueAtTime(0.0001, at + dur);
    o.connect(gg).connect(out); o.start(at); o.stop(at + dur + 0.05);
  };
  const b = t + 0.08;
  bell(2093, b, 0.9, 0.22); bell(2637, b + 0.005, 0.8, 0.16); bell(3136, b + 0.01, 0.7, 0.12); bell(4186, b + 0.015, 0.5, 0.06);
  // coins: short random high clicks
  for (let k = 0; k < 6; k++) bell(3000 + Math.random() * 2500, b + 0.25 + k * 0.06 + Math.random() * 0.03, 0.12, 0.07);
};
